import React, { ReactNode } from 'react';
import { GridItemCount } from '../../../GridPeripherals/GridItemCount';
import { ProductListingMobileHeaderTitle } from '../ProductListingMobileHeaderTitle';
import './ProductListingMobileHeader.scss';

type Props = {
  headerText: string | undefined;
  totalItems: number;
  belowHeader?: ReactNode;
};

export const ProductListingMobileHeader: React.FC<Props> = ({
  headerText,
  totalItems,
  belowHeader
}) => (
  <div className="ProductListingMobileHeader">
    <ProductListingMobileHeaderTitle headerText={headerText} />

    {belowHeader}

    <GridItemCount className="ProductListingMobileHeader__count" count={totalItems} />
  </div>
);
